export default __webpack_public_path__ + "static/media/simple-Line-Icons.549254fc.ttf";